(function keepBodyLayoutClasses() {
    const required = (document.body.getAttribute('data-required-classes') || '')
        .split(/\s+/)
        .filter(Boolean);
    if (!required.length) return;

    const apply = () =>
        required.forEach((cls) => document.body.classList.contains(cls) || document.body.classList.add(cls));
    apply();
    new MutationObserver(apply).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
